module.exports = __webpack_public_path__ + "public/SiteImages/appStore.png?7c01df0b";